import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import { PumpBasalRateState } from "@tandemdiabetes/sugarmate-api-react-client"
import { Modal } from "@tandemdiabetes/sugarmate-react-components"
import type {
  ComponentPropsWithoutRef,
  ForwardedRef,
} from "react"
import {
  useCallback,
  useState,
  forwardRef,
} from "react"

import { PumpStatusBarComponent } from "./PumpStatusBarComponent"
import { PumpStatusMalfunctionModalContent } from "./PumpStatusMalfunctionModalContent"
import { PumpStatusModalContent } from "./PumpStatusModalContent"

interface Props extends Omit<ComponentPropsWithoutRef<"button">, "onClick"> {
  pumpStatus: PumpStatus;
}

export const PumpStatusBar = forwardRef<HTMLButtonElement, Props>(
  function PumpStatusBar(props: Props, propRef: ForwardedRef<HTMLButtonElement>) {
    const {
      pumpStatus,
      ...buttonProps
    } = props

    const [
      isModalOpen,
      setIsModalOpen,
    ] = useState<boolean>(false)

    const openPumpStatusModal = useCallback(
      () => {
        setIsModalOpen(true)
      },
      [setIsModalOpen],
    )

    const pumpMalfunction = pumpStatus.basal_rate_state === PumpBasalRateState.PumpMalfunction

    return (
      <Modal
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
      >
        <PumpStatusBarComponent
          {...buttonProps}
          pumpMalfunction={pumpMalfunction}
          onClick={openPumpStatusModal}
          ref={propRef}
          pumpStatus={pumpStatus}
        />
        {pumpMalfunction
          ? <PumpStatusMalfunctionModalContent pumpStatus={pumpStatus} />
          : (
            <PumpStatusModalContent pumpStatus={pumpStatus} />
          )
        }
      </Modal>
    )
  },
)
